import * as reactRedux from "react-redux";
import type { RootState, AppDispatch } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => reactRedux.useDispatch<AppDispatch>()
export const useAppSelector: reactRedux.TypedUseSelectorHook<RootState> = reactRedux.useSelector
